import React, { useEffect } from "react";
import useWindowDimensions from "../hooks/useWindowDimensions";
import globalState from '../state/GlobalState';
import { useState } from '@hookstate/core';
import { useTranslation } from 'react-i18next';
import { useSwipeable } from 'react-swipeable';
import { useTheme } from '@material-ui/core/styles';
import * as rdd from 'react-device-detect';
import isWebview from 'is-ua-webview';
import NavigationHelper from '../utils/NavigationHelper';
import LeftChevronIcon from '../assets/img/svg/left-chevron.svg';
import ChiliNoLogo from '../assets/img/svg/ChiliNoLogoSmall.svg';
import { Grid } from "@material-ui/core";
import { Link } from 'react-tiger-transition';

const PageContainer = (props) => {
    const wDim = useWindowDimensions();
    const gstate = useState(globalState);
    const { t } = useTranslation();
    const theme = useTheme();
    const swipeHandler = useSwipeable({
        onSwipeStart: (eventData) => {
            if (eventData.dir === 'Right') {
                var el = window.document.getElementById('back');
                if (el) {
                    el.click();
                }
            }
        }
        //...config,
    });
    useEffect(() => {
        // code to run on component mount
    }, [])

    return (
        <React.Fragment>
            <div {...swipeHandler} style={{ overflowY: rdd.isFirefox ? 'auto' : wDim.desktop ? 'overlay' : 'scroll', height: wDim.height, WebkitOverflowScrolling: 'touch', scrollbarWidth: rdd.isFirefox ? 'thin': null }} className={props.noSelect ? 'noselect' : ''}>
                <Grid container direction="row" justify="space-around" alignItems="center">
                    <div style={{ maxWidth: wDim.desktop ? '370px' : 'unset', width: '100%', padding: wDim.width <= 320 ? '35px 7px' : '35px 17px' }}>
                        {rdd.isIOS && isWebview && <div style={{ width: '100%', height: '10px' }} />}
                        <Grid container direction="row" justify="space-between" alignItems="center">
                            {props.back && <div><Link id="back" replace to={gstate.topModuleUrl.get() ? gstate.topModuleUrl.get() : '/home'} transition="glide-right" style={{ textDecoration: 'none', fontSize: '14px', fontFamily: theme.typography.fontFamily2, fontWeight: 300 }}><img src={LeftChevronIcon} height="32" alt="" style={{ marginTop: '-5px', marginRight: '-6px' }} /><div style={{ verticalAlign: 'top', marginTop: '2px', color: theme.palette.primary.main, display: 'inline-block' }}>{gstate.topModuleName.get()}</div></Link></div>}
                            {props.logo && <div style={{ width: '54px' }}><img src={ChiliNoLogo} height="32" alt="" /></div>}
                            {props.title && <div style={{ fontSize: '20px', fontWeight: '700' }}>{props.title}</div>}
                            <div style={{ width: '50px' }}></div>
                        </Grid>
                        <Grid container direction="column" justify="space-around" alignItems="center">
                            {props.children}
                        </Grid>
                    </div>
                </Grid>
            </div>
        </React.Fragment>
    );
};

export default PageContainer;